export default __webpack_public_path__ + "static/story_corps-9e363c0cee10d69897eb37e69e10851f.png";